import { s as makeRestApiRequest } from "./utils2.mjs";

//#region src/api/externalSecrets.ee.ts
const getExternalSecrets = async (context) => {
	return await makeRestApiRequest(context, "GET", "/external-secrets/secrets");
};
/**
* @beta still under development
*/
const getGlobalExternalSecrets = async (context) => {
	return await makeRestApiRequest(context, "GET", "/secret-providers/completions/secrets/global");
};
/**
* @beta still under development
*/
const getProjectExternalSecrets = async (context, projectId) => {
	return await makeRestApiRequest(context, "GET", `/secret-providers/completions/secrets/project/${projectId}`);
};
const getExternalSecretsProviders = async (context) => {
	return await makeRestApiRequest(context, "GET", "/external-secrets/providers");
};
const getExternalSecretsProvider = async (context, id) => {
	return await makeRestApiRequest(context, "GET", `/external-secrets/providers/${id}`);
};
const testExternalSecretsProviderConnection = async (context, id, data) => {
	return await makeRestApiRequest(context, "POST", `/external-secrets/providers/${id}/test`, data);
};
const updateProvider = async (context, id, data) => {
	return await makeRestApiRequest(context, "POST", `/external-secrets/providers/${id}`, data);
};
const reloadProvider = async (context, id) => {
	return await makeRestApiRequest(context, "POST", `/external-secrets/providers/${id}/update`);
};
const connectProvider = async (context, id, connected) => {
	return await makeRestApiRequest(context, "POST", `/external-secrets/providers/${id}/connect`, { connected });
};

//#endregion
export { getGlobalExternalSecrets as a, testExternalSecretsProviderConnection as c, getExternalSecretsProviders as i, updateProvider as l, getExternalSecrets as n, getProjectExternalSecrets as o, getExternalSecretsProvider as r, reloadProvider as s, connectProvider as t };
//# sourceMappingURL=externalSecrets.ee.mjs.map